import React, { useState, Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const AdminCustomDropdown = ({
  icon: Icon,
  options,
  selectedProfession,
  classes,
  textClasses,
  leftIconClasses,
  rightIconClasses,
  menuClasses,
  name,
  formik,
  selectedOption,
  setSelectedOption,
  handleChange,
}) => {
  const handleOptionClick = (option) => {
    let updatedValues = selectedOption;
    let foundItem = selectedOption.find((opt) => opt.id === option.id);
    if (foundItem) {
      updatedValues = selectedOption.filter((opt) => opt.id !== option.id);
    } else {
      updatedValues = [...selectedOption, option];
    }
    setSelectedOption && setSelectedOption(updatedValues);
  };

  return (
    <div className="w-full md:w-auto">
      <div className={`${classes} relative`}>
        <Menu as="div" className="text-left w-full">
          <div className="flex items-center">
            <Menu.Button className={`${textClasses}`}>
              {Icon && (
                <span className="pr-[10px] border-solid border-[#CCD0D4] border-r bg-transparent">
                  <Icon className={`${leftIconClasses}`} />
                </span>
              )}
              {selectedOption?.map((option) => (
                <span
                  className={`inline-flex pr-1 items-center rounded-md px-2 py-1 text-xs font-medium text-white`}
                  style={{backgroundColor: option.color}}
                >
                  {option?.name}
                  <XMarkIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOptionClick(option);
                    }}
                    className="text-white w-4 h-4 cursor-pointer"
                    aria-hidden="true"
                  />
                </span>
              ))}
              {selectedOption.length < 1 && (
                <div className="text-sm text-customGray">Select Status...</div>
              )}

              <span className="absolute inset-y-0 right-[14px] flex items-center pl-[10px] border-l border-solid border-[#CCD0D4] h-6 my-auto">
                <ChevronDownIcon
                  className={`${rightIconClasses}`}
                  aria-hidden="true"
                />
              </span>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-y-95"
            enterTo="transform opacity-100 scale-y-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-y-100"
            leaveTo="transform opacity-0 scale-y-95"
          >
            <Menu.Items className={`${menuClasses}`}>
              <div className="py-1">
                {options?.map((option, index) => (
                  <Menu.Item key={option}>
                    {({ active }) => (
                      <a
                        id={`option-${index}`}
                        onClick={() => handleOptionClick(option)}
                        className={classNames(
                          active
                            ? "bg-[#EBF7FF] text-primary"
                            : "text-[#485868]",
                          "block px-4 py-2 text-sm cursor-pointer"
                        )}
                      >
                        {option.name}
                      </a>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      {/* {formik?.touched[name] && formik?.errors[name] && (
        <p className="text-red-500 text-xs leading-[160%] font-bold mb-4 -mt-4 block">
          {formik?.touched[name] && formik?.errors[name]}
        </p>
      )} */}
    </div>
  );
};

export default AdminCustomDropdown;
